import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
    selector: 'shared-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingComponent {
    @Input() public isLoading: boolean | null = false;
}
